import { Grid, Card, CardContent } from '@mui/material';
import { CajasProvider } from "../../../context/CajasContext/CajasContext";
import { ImportFile } from "../components/ImportFile";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import UploadFileIcon from "@mui/icons-material/UploadFile";

export const ImportacionContenidos = () => {
  return (
    <Grid style={{ marginBottom: "50px", paddingTop: 10 }}>
      <PageHeaderCard title="Importación de Contenidos" icon={<UploadFileIcon />} />
      <Card elevation={3} sx={{ mt: 2 }}>
        <CardContent sx={{ p: { xs: 2, sm: 4, md: 6 } }}>
          <CajasProvider>
            <ImportFile />
          </CajasProvider>
        </CardContent>
      </Card>
    </Grid>
  );
}
